import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLocationsLoading = (isLoading) => {
  return {
    type: actionTypes.SET_LOCATIONS_LOADING,
    payload: isLoading
  }
}
